import React, { PureComponent } from "react"

import {
  BarChart,
  Bar,
  ReferenceLine,
  ResponsiveContainer,
  YAxis,
  XAxis,
  PieChart,
  Pie,
  Cell,
  Label
  } from "recharts"

import { Metric, Error, selectFormat } from "./../Utils/Utils.js"

import Heading from "./../Elements/Heading"

class CostBudget extends PureComponent {
  render() {
    const { data: _data } = this.props

    const data = {
      budget_bar_chart: [{
        spent: 120000,
        range: [100000, 130000]
      }],
      budget_spent: {
        value: 120000
      },
      budget_last_period: {
        period: 'Last 7 days',
        value: 50000
      },
      budget_remaining: {
        value: 68
      }
    }
    const pie_data = [
      data.budget_remaining,
      { value: 100 - data.budget_remaining.value }
    ];

    if (_data.hasData === false) {
      return <Error minHeight={360} />
    }

    const COLORS = [
      data.budget_bar_chart[0].spent < data.budget_bar_chart[0].range[1] ? "green" : 'red',
      '#f4f4f4'
    ];

    const range = data.budget_bar_chart[0].range;

    return [
      <div key={"a"} className="row border-between-metrics mt-lg-0 mt-3 pt-4 pt-lg-0">
        <div className="col-12 col-lg-4 mb-3">
          <Heading size={6} className="">Budget Spent</Heading>
          <ResponsiveContainer height={90}>
            <BarChart
              data={data.budget_bar_chart}
              layout="vertical"
              margin={{ top: 14, right: 0, left: 0, bottom: 20 }}
            >
              <XAxis type="number" hide domain={[0, range[0] + range[1]]}/>
              <YAxis type="category" hide />

              <defs>
                <linearGradient
                  id="budget-gradient"
                  x1="1"
                  y1="0"
                  x2="0"
                  y2="0"
                >
                  <stop offset="5%" stopColor="#FAA461" stopOpacity={1} />
                  <stop offset="95%" stopColor="#FC6D52" stopOpacity={1} />
                </linearGradient>
              </defs>

              <Bar
                dataKey="spent"
                fillOpacity={1}
                fill="url(#budget-gradient)"
                background={{ fill: '#f2f2f2' }}
              />

              <g className="recharts-layer recharts-reference-line">
                <line className="recharts-reference-line-line"
                    x1="0" y1="100" x2="0" y2="10" 
                    stroke="#FC6D52" 
                    strokeDasharray="3 3" 
                    fill="none" 
                    fillOpacity="1" 
                    strokeWidth="1">
                </line>
                <text className="recharts-text recharts-label"
                      x="2" 
                      y="87" 
                      fill="green"
                      textAnchor="start"><tspan x="2" dy="0em" fontSize="0.65rem">on plan</tspan>
                </text>
              </g>

              <ReferenceLine
                x={range[0]}
                stroke="#949494"
                strokeDasharray="3 3"
                ifOverflow="extendDomain"
                isFront={true}
              >
                <Label position="bottom" content={({viewBox: {x, y, height}}) => <text x={x} y={y + height} textAnchor="middle" fontSize="0.8rem" dy={16}>{selectFormat("currency", range[0])}</text>}/>
              </ReferenceLine>

              <ReferenceLine
                x={range[1]}
                stroke="#949494"
                strokeDasharray="3 3"
                ifOverflow="extendDomain"
                isFront={true}
              >
                <Label position="bottom" content={({viewBox: {x, y, height}}) => <text x={x} y={y + height} textAnchor="middle" fontSize="0.8rem" dy={16}>{selectFormat("currency", range[1])}</text>}/>
              </ReferenceLine>

              <ReferenceLine
                x={(range[0] + range[1])/2}
                stroke="none"
                strokeDasharray="3 3"
                ifOverflow="extendDomain"
                isFront={true}
              >
                <Label position="top" content={({viewBox: {x, y}}) => <text x={x} y={y} fill="#949494" textAnchor="middle" fontSize="0.65rem" dy={-6}>Expected Range</text>}/>
              </ReferenceLine>
            </BarChart>
          </ResponsiveContainer>   
        </div>
        
        <div className="col-3 col-md-2 col-lg-1 no-left-border-before">
          <Heading size={6}>Spent as of <br /> Today</Heading>
          <div style={{marginTop: 28}}>
            <Metric {...data.budget_spent} size={"sm"} type={"currency"} />
          </div>
        </div>

        <div className="col-3 col-md-2 col-lg-1">
          <Heading size={6} color={"#666"}>
            Budget for <br /> {data.budget_last_period.period}
          </Heading>
          <div style={{marginTop: 28}}>
            <Metric {...data.budget_last_period} size={"sm"} type={"currency"} />
          </div>
        </div>
        
        <div className="col-3 col-md-2 col-lg-1">
          <Heading size={6}>% of Budget <br /> Remaining</Heading>
          <div style={{marginTop: 13}}>
            <PieChart height={50} width={50} >
              <Pie dataKey="value" data={pie_data} outerRadius="100%" innerRadius="75%" startAngle={450} endAngle={90}>
                {
                  pie_data.map((entry, index) => (
                    <Cell key={`cell-${entry}`} fill={COLORS[index]} />
                  ))
                }
              </Pie>
              <text x="50%" y="50%" dy=".12rem" textAnchor="middle" dominantBaseline="middle" className="piechart-metric__small">
                {selectFormat('percentage', pie_data[0].value / 100)}
              </text>
            </PieChart>
          </div>
        </div>

      </div>
    ]
  }
}

export default CostBudget
